import './index.scss';
import LogoR from '../../assets/images/logo-R(1).png';
import {useState, useEffect} from 'react';
import AnimatedLetters from '../AnimatedLetters';
import Logo from './Logo';
import Loader from 'react-loaders';

const Home = () =>{

    const [letterClass, setLetterClass] = useState('text-animate');

    const nameArray = ['o','h','a','n',' ','S','i','n','g','h',' ','L','e','e','k','h','a',',']

    const jobArray = ['m','a','c','h','i','n','e',' ','l','e','a','r','n','i','n','g',' ','e','n','g','i','n','e','e','r']

    useEffect(() => {
        setTimeout(() => {
          return setLetterClass('text-animate-hover')
        }, 6000)
      }, [])
      
    return (
        <div>
            <div className = 'container home-page'>
                <div className = 'text-zone'>
                    <h1> 
                        <AnimatedLetters letterClass={letterClass} strArray={['H','i',',']} idx = {10}/>
                        <br/>
                        <AnimatedLetters letterClass={letterClass} strArray={['I','’','m']} idx = {13}/>
                        <img src = {LogoR} alt='logo'/>
                        <AnimatedLetters letterClass={letterClass} strArray={nameArray} idx = {16}/>
                        <br/>
                        <AnimatedLetters letterClass={letterClass} strArray={jobArray} idx = {35}/>
                    </h1>

                    <h2>
                        keywords: machine learning, deep learning, python,  google-scholar, eugenia h. rho
                    </h2>
                </div>

                <Logo />

            </div>

            <Loader type='pacman'/>
        </div>
    )
}

export default Home;